import { render, staticRenderFns } from "./ArchivePurchaseOverseasStockings.vue?vue&type=template&id=63dc9d52&"
import script from "./ArchivePurchaseOverseasStockings.vue?vue&type=script&lang=js&"
export * from "./ArchivePurchaseOverseasStockings.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePurchaseOverseasStockings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePurchaseOverseasStockings.vue"
export default component.exports